import _ from 'lodash';
/*
此資料 base on API-39 的回傳
 */
const state = () => ({
    Policy302s: null,
    Insures: null,
    Hccs: null,
});

const actions = {};

const getters = {};

const mutations = {
    /**
     * 清除資料
     * @param {*} state
     */
    clear(state) {
        _.forEach(state, (value, key) => {
            state[key] = null;
        });
    },
    /**
     * API-39 的回傳資料
     */
    setData(state, payload) {
        if (!payload) return;

        _.forEach(state, (value, key) => {
            if (typeof payload[key] !== 'undefined') {
                state[key] = payload[key];
            }
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
